export default {
    title: "Beraterempfehlungen",
    noItems: "Keine Empfehlungen"
}